export type MeasureTrack = (
  event: string,
  data: Record<string, unknown>,
) => void;
export type MeasureReportError = (
  error: unknown,
  tags?: Record<string, string>,
) => void;

let sinks: { track: MeasureTrack; reportError: MeasureReportError } = {
  track: () => {},
  reportError: () => {},
};

export function setMeasureTelemetry(t: {
  track: MeasureTrack;
  reportError: MeasureReportError;
}): void {
  sinks = t;
}

export function track(event: string, data: Record<string, unknown>): void {
  sinks.track(event, data);
}

export function reportError(
  error: unknown,
  tags?: Record<string, string>,
): void {
  if (tags === undefined) {
    // Forward without a trailing `undefined` argument.
    (sinks.reportError as (error: unknown) => void)(error);
    return;
  }
  sinks.reportError(error, tags);
}
